import { LogLevel } from '../app/core/services/logger/log-level.enum';
import { LOG_LEVEL, LOGGER_PROVIDERS } from '../app/core/injection-tokens';
import { LogConsoleService } from '../app/core/services/logger/logger-providers/log-console-service/log-console.service';

const API_URL = 'https://api-h2adhbejathxa7g6.a02.azurefd.net:443/tst/ssba-otf-backend';

export const environment = {
    production: false,
    apiUrl: API_URL,
    stage: 'test',
    useMockAuth: false,
    providers: [
        { provide: LOG_LEVEL, useValue: LogLevel.DEBUG },
        { provide: LOGGER_PROVIDERS, useClass: LogConsoleService, multi: true },
    ],
    msalConfig: {
        auth: {
            clientId: 'ea22b231-4cb8-4a9b-ae7d-c501ca71ca73',
        },
        redirectUri: '/',
    },
    apiConfig: {
        scopes: ['https://healthciam.onmicrosoft.com/auc-ssba-otf-dev-appreg-webapp/access.backend'],
        uri: API_URL,
    },
    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1A_B_SSBA_OTF',
            resetPassword: 'b2c_1_reset',
            editProfile: 'b2c_1_edit_profile',
        },
        authorities: {
            signUpSignIn: {
                authority: 'https://healthciam.b2clogin.com/healthciam.onmicrosoft.com/B2C_1A_B_SSBA_OTF',
            },
            resetPassword: {
                authority: 'https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/b2c_1_reset',
            },
            editProfile: {
                authority: 'https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/b2c_1_edit_profile',
            },
        },
        authorityDomain: 'healthciam.b2clogin.com',
    },
};
